// extracted by mini-css-extract-plugin
export default {"noservice-title":"pwu44_noservice-title"};